import { useEffect } from 'react';
import { EnumDropdown, EnumDropdownProps, useInputHelper, useFormContext } from 'framework/form';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import useConversionRouteHelper from '../route/hooks/useConversionRouteHelper';
import { EMPLOYEE_TYPES, EMPLOYEE_TYPES_ALIAS } from '../constants';

const EmployeeTypeDropdown = (props: Omit<EnumDropdownProps, 'options'>) => {
  const { candidateId } = useConversionRouteHelper();
  const { isFeatureEnabled } = useFeatureToggle();
  const positionSlotsEnabled = isFeatureEnabled(Features.POSITION_SLOTS);
  const { getValue } = useInputHelper(props);
  const { initializeValue } = useInputHelper({ source: 'initialEmployeeType' });
  const { isCreateRequest } = useFormContext();

  const roles: Dictionary<string> = { ...EMPLOYEE_TYPES };
  if (getValue() !== EMPLOYEE_TYPES_ALIAS.INTERN) {
    delete roles.INTERN;
  }
  if (candidateId && !positionSlotsEnabled) {
    delete roles.CONTRACTOR;
  }

  useEffect(() => {
    if (isCreateRequest === false) {
      initializeValue(getValue());
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <EnumDropdown {...props} placeholder="Choose Type" options={roles} />;
};

export default EmployeeTypeDropdown;
